<h3 class="vc-title-s register__title" i18n="@@REGISTER_MODAL.TITLE">Join our Community</h3>
<p class="register__discount" i18n="@@REGISTER_MODAL.DISCOUNT">Get {{ promoOffer }} off your first order</p>

<div class="register__newsletterContainer">
  <form
    novalidate
    [formGroup]="newsletterForm"
    id="formNewsletter"
    class="register__formNewsletter"
    (ngSubmit)="onSubmit()"
  >
    <p *ngIf="error" aria-live="assertive" class="vc-form__error">{{ error }}</p>
    <div class="form-group vc-form-text register__field register__vcregister">
      <input type="email" id="user_email" class="vc-form-text__input" formControlName="email" required />

      <label class="vc-form-text__label" for="user_email">
        <div *ngIf="email.errors && email.dirty" aria-live="assertive">
          <span *ngIf="email?.errors.required" i18n="@@LOGIN_MODAL.ERROR_REQUIRED_EMAIL">Email is required</span>
          <span *ngIf="email?.errors.pattern" i18n="@@LOGIN_MODAL.ERROR_PATTERN_EMAIL">Incorrect email address</span>
        </div>

        <span *ngIf="email.valid || !email.dirty" i18n="@@REGISTER_MODAL.EMAIL">Email *</span>
      </label>
    </div>

    <p class="register__requiredFieldMention" i18n="@@REGISTER_MODAL.MANDATORY_FIELD">* Required field</p>

    <button
      class="vc-btn vc-btn--large vc-btn--full vc-btn--primary"
      type="submit"
      [disabled]="pending || !newsletterForm.valid"
      i18n="@@REGISTER_MODAL.JOIN_COMMUNITY_BUTTON"
    >
      Join the community
    </button>
  </form>

  <div class="register__or">ou</div>

  <vc-facebook-connect
    class="register__facebookregister"
    [type]="'register'"
    (registerNextStep)="setUserFromFacebook($event)"
  ></vc-facebook-connect>

  <div class="register__cgu">
    <form [formGroup]="newsletterForm">
      <div class="vc-form-checkbox">
        <input
          class="vc-form-checkbox__input"
          formControlName="opted"
          id="user_optin"
          type="checkbox"
          autocomplete="off"
          checked
          [formControl]="registerCgu"
          [attr.aria-checked]="registerCgu.value ? 'checked' : ''"
        />
        <label class="vc-form-checkbox__label" for="user_optin" i18n="@@REGISTER_MODAL.RECEIVE_OFFERS_NEWS_CHECKBOX"
          >Receive all offers, trends and actions from Vestiaire Collective</label
        >
      </div>
    </form>
  </div>
</div>
